module.exports = __webpack_public_path__ + "static/media/leasing-logo-hld.e7c29fbd.jpg";